import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from "@mui/material";

// Trimmed version of denzo-waiter's CancelReasonDialog — fixed to
// cancel_type: 'return' (a driver cancelling here means "delivery failed and
// the order is coming back", not any of the other cancel_type values that
// dialog offers for in-store order edits), so there's no type selector, just
// the required reason.
export default function CancelReturnDialog({ order, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!order) return null;

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setSaving(true);
    setError("");
    try {
      await onConfirm(reason.trim());
    } catch (err) {
      setError(err.message || "Failed to cancel order");
      setSaving(false);
    }
  };

  return (
    <Dialog open onClose={saving ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Cancel as Return — #{order.order_no || order.id}</DialogTitle>
      <DialogContent>
        {error && (
          <Typography color="error" variant="body2" sx={{ mb: 1.5 }}>
            {error}
          </Typography>
        )}
        <TextField
          label="Reason"
          fullWidth
          multiline
          minRows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          autoFocus
          placeholder="Why did the delivery fail?"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Back
        </Button>
        <Button variant="contained" color="error" disabled={saving || !reason.trim()} onClick={handleConfirm}>
          {saving ? "Saving..." : "Confirm Return"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
